import { SearchOutlined } from '@ant-design/icons';
//import Table from '../../components/CardTable/CardTable';
//Table ant design
import { Table } from 'ant-table-extensions';
import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, Image, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import defaultLogo from '../../assets/images/avatar.png';
import { timestampToDate } from '../../common/handleTimestamp';
import DropdownEditDevice from '../../components/Dropdown/DropdownEditDevice';
import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import {
  allCustomerInfos, getDataCustomers
} from '../Customers/CustomersSlice';
import { tenantDeviceInfos } from '../Dashboard/DashboardSlice';
import { allDevicesCustomer, getDataDevice } from './DeviceSlice';

const Device = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const allDevices = useSelector(allDevicesCustomer);
  const dataCustomers = useSelector(allCustomerInfos);
  const deviceStatus = useSelector((state) => state.device.status);

  const [customerName, setCustomerName] = useState('');
  const token = localStorage.getItem('token');

  const { customer_id } = useParams();
  const customerId = customer_id;

  const [curPage, setCurPage] = useState(1);
  const [pagination, setPagination] = useState({
    current: curPage,
    pageSize: 10,
    total: 10,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getDataCustomers({ token }));
    dispatch(tenantDeviceInfos({ token }));
  }, [dispatch, token]);

  useEffect(() => {
    const curCustomer = dataCustomers.data?.filter(
      (item) => customerId === item.id.id
    )[0];
    setCustomerName(curCustomer?.name);
  }, [dataCustomers, customerId]);

  useEffect(() => {
    const pageSize = 1000;
    const page = pagination.current - 1;
    dispatch(getDataDevice({ token, customerId, pageSize, page }));
  }, [dispatch, token, customerId]);

  useEffect(() => {
    if (deviceStatus === 'loading') {
      setLoading(true);
    } else {
      setPagination({ ...pagination, total: allDevices?.totalElements });
      setLoading(false);
    }
  }, [deviceStatus]);

  if (deviceStatus === 'success') {
    const pageSize = pagination.pageSize;
    const page = pagination.current - 1;
    dispatch(getDataDevice({ token, customerId, pageSize, page }));
    setLoading(false);
  }

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      render: ([deviceId, deviceProfileId, customerId]) => (
        <DropdownEditDevice
          deviceId={deviceId}
          deviceProfileId={deviceProfileId}
          customerId={customerId}
        />
      ),
      width: 200,
    },
    {
      title: t('').toUpperCase(),
      dataIndex: 'image',
      key: 'image',
      render: ([avatar, title]) => (
        <Image
          width={40}
          height={40}
          src={avatar ? avatar : defaultLogo}
          alt={title}
          style={{ borderRadius: '10px', objectFit: 'scale-down' }}
        />
      ),
      width: 60,
    },
    {
      title: t('name-device').toUpperCase(),
      dataIndex: 'name',
      key: 'name',
      render: ([id, nameDevice, label]) => (
        <Link to={`/attribute/${id}`}>
          <span style={{ fontWeight: 'bold' }}>
            {nameDevice} <br />
            <span style={{ color: '#888' }}>{label}</span>
          </span>
        </Link>
      ),
      width: 300,
    },
    {
      title: t('container').toUpperCase(),
      dataIndex: 'container',
      key: 'container',
      width: 350,
    },
    {
      title: t('connect').toUpperCase(),
      dataIndex: 'connect',
      key: 'connect',
      render: ([lastConnectTime, lastDisconnectTime]) => (
        <div>
          {lastConnectTime > lastDisconnectTime ? (
            <Badge pill bg="success" text="light">
              {t('online')}
            </Badge>
          ) : (
            <Badge pill bg="secondary" text="light">
              {t('offline')}
            </Badge>
          )}
          <br />
          <span>
            {lastConnectTime > lastDisconnectTime
              ? `${t('last-connected')}: ${timestampToDate(lastConnectTime)}`
              : `${t('last-disconnected')}: ${timestampToDate(
                  lastDisconnectTime
                )}`}
          </span>
        </div>
      ),
    },
  ];

  const data = allDevices?.map((item, idx) => ({
    key: idx,
    index: [item.id.id, item.deviceProfileId.id, customerId],
    image: [item.attributes.avatar, item.title],
    name: [item.id.id, item.name, item.label],
    container: item.additionalInfo.description,
    connect: [
      item.attributes.lastConnectTime,
      item.attributes.lastDisconnectTime,
    ],
  }));

  const handleTableChange = (pagination, filters, sorter) => {
    if (curPage !== pagination.current) {
      const pageSize = pagination.pageSize;
      const page = pagination.current - 1;
      dispatch(getDataDevice({ token, customerId, pageSize, page }));
      setCurPage(pagination.current);
    }
    setPagination(pagination);
  };

  return (
    <section className="pcoded-main-container">
      <div className="pcoded-wrapper">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <Breadcrumbs
                  floor={[
                    { name: t('customer'), href: '/customers' },
                    {
                      name: customerName,
                      href: 'null',
                      style: {
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        color: 'gray',
                      },
                    },
                  ]}
                />
                <div className="page-header">
                  <div className="page-block"></div>
                </div>
                <Row>
                  <Col>
                    <Card>
                      <Card.Header>
                        <h5>{t('device-management')}</h5>
                      </Card.Header>
                      <Card.Body>
                        <Table
                          columns={columns}
                          dataSource={data}
                          pagination={pagination}
                          loading={loading}
                          onChange={handleTableChange}
                          scroll={{ x: true }}
                          searchableProps={{
                            inputProps: {
                              placeholder: t('search-table'),
                              prefix: <SearchOutlined />,
                              style: {
                                maxWidth: '350px',
                                padding: '6px',
                                borderRadius: '5px',
                              },
                            },
                            fuzzySearch: true,
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Device;
